import api from './api';

// Service d'authentification
const authService = {
  // Connexion
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    
    // Stocker les informations utilisateur (le token est géré via cookie)
    if (response.data.success) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  },
  
  // CORRECTION: Déconnexion améliorée
  logout: async () => {
    try {
      // Appeler l'API de déconnexion avec un timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 secondes timeout
      
      await api.post('/auth/logout', {}, {
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      console.log('API logout appelée avec succès');
      
    } catch (error) {
      console.error('Erreur lors de l\'appel API logout:', error);
      // Ne pas bloquer la déconnexion si l'API échoue
    } finally {
      // Toujours nettoyer le localStorage, même si l'API échoue
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('maintain_session');
    }
  },
  
  // Obtenir l'utilisateur courant
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  
  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    return !!localStorage.getItem('user');
  }
};

export default authService;